import { Component, OnInit } from '@angular/core';
import { Painting } from 'src/app/models/painting.model';
import { PaintingService } from 'src/app/services/painting.service';
import { Router } from '@angular/router';
import { NbDialogService } from '@nebular/theme';
import { ConfirmboxComponent } from '../../shared/confirmbox/confirmbox.component';

@Component({
  selector: 'app-editpage',
  templateUrl: './editpage.component.html',
  styleUrls: ['./editpage.component.scss'],
})
export class EditpageComponent implements OnInit {
  paintings: Painting[];

  constructor(
    private _paintingService: PaintingService,
    private _router: Router,
    private _dialogService: NbDialogService,
  ) {}

  ngOnInit(): void {
    this._paintingService
      .getAll()
      .subscribe((paintings) => (this.paintings = paintings));
  }
  toEdit(id: number) {
    console.log(id);
    this._router.navigate([`editpaintings/${id}`]);
  }
  toDelete(id: number) {
    let confirmBox = this._dialogService.open(ConfirmboxComponent, {
      context: {
        name: this.paintings.find((paintings) => paintings.id == id).name,
      },
      closeOnBackdropClick: false,
    });
    confirmBox.onClose.subscribe((yesOrNo) => {
      if (yesOrNo) {
        this._paintingService
          .delete(id)
          .subscribe(
            () => (this.paintings = this.paintings.filter((painting) => painting.id !== id))
          );
        this._router.navigate(['/works']);
      }
    });
  }
}
